const layerSelectedReducer = (state = {'id': 'VECTOR.gfs_0.25_air_temperature_2m.default', 'name': 'Temperature'}, action) => {
  switch(action.type) {
    case 'LAYER_SELECTED':
      return action.payload;
    default:
      return state
    }
  }

  export default layerSelectedReducer;